import { API, API_URL } from '@/config';

export default {
  name: 'BannerPopup',

  props: {
    banner: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    showResult: false,
    resultText: '<<>>',
  }),

  methods: {
    close() {
      this.showResult = false;
      this.$EventBus.$emit('Banner/CLOSE_MODAL_WITH_POPUP');
    },
    buttonAction(bannerId, action, clickMessage) {
      API.post(`${API_URL}/settings/baners/action`, { banner: bannerId, action }).then((result) => {
        this.resultText = (result.data.code === 200 || result.data.code === 0) ? clickMessage :
          'Niestety wystąpił błąd. Możesz spróbować później, klikając w baner po prawej stronie.';
        this.showResult = true;
      });
    },
  },

};



// WEBPACK FOOTER //
// ./src/components/Modals/BannerPopup/component.js